import React from 'react';
import {UserInsights} from "types/User";
import StatList from "components/StatList";
import StatBoxSimple from "components/StatBoxSimple";
import {secondsToHuman} from "services/date";
import Card from "components/Card";

// Types ----

type QuizzesCardProps = {
  insights?: UserInsights | null
}

// Component ----

function QuizzesCard({insights}: QuizzesCardProps) {
  return (
    <Card heading="Quizzes">
      <StatList columns={2}>
        <StatBoxSimple name='Started' stat={insights?.education.all_quiz_attempts}/>
        <StatBoxSimple name='Completed' stat={insights?.education.completed_quiz_attempts}/>
        <StatBoxSimple name='Average Score' stat={insights?.education.quiz_score_percent + '%'}/>
        <StatBoxSimple name='Average Time' stat={secondsToHuman(insights?.education.quiz_attempt_duration)}/>
      </StatList>
    </Card>
  );
}

// Export ----

export default QuizzesCard;